module.exports = __webpack_public_path__ + "static/media/Single Matting Vertical Text.8426b2e0.png";